import React from 'react';
import { MODAL_SIZE } from '../../../components/Modal/Modal';
import { Button, ModalBody, ModalFooter } from 'reactstrap';
import ButtonLoader from '../../../components/Layout/Buttons/ButtonLoader';
import Rodal from '../../../components/Rodal/Rodal';
import { DialogMode } from './TeamMemberModal';
import { createPortal } from 'react-dom';

export interface RemoveTeamMemberModalProps {
    isVisible: boolean;
    dialogMode: DialogMode;
    isSendingRequest: boolean;
    setDialogMode: (mode: DialogMode) => void;
    setIsDeleteDialogVisible: (visible: boolean) => void;
    remove: () => void;
}

export const RemoveTeamMemberModal = (props: RemoveTeamMemberModalProps) => {
    return createPortal(
        <Rodal
            visible={props.isVisible}
            onClose={() => props.setIsDeleteDialogVisible(false)}
            animation={'fade'}
            showMask={true}
            width={400}
            className="remove-associate-member-popup-portal">
            <ModalBody className="body">
                <h6 className="header">
                    Are you sure you want to remove this Team Member?
                </h6>
                <p className="secondary-text">
                    Doing so will remove the team member from your
                    team member list.
                </p>
                <div className="footer-wrapper">
                    <Button
                        className="no-edit-button"
                        onClick={() => props.setIsDeleteDialogVisible(false)}>
                        No
                    </Button>
                    <ButtonLoader
                        buttonText={'Yes'}
                        loaderButtonText={'Yes'}
                        disabled={false}
                        isLoading={props.isSendingRequest}
                        onClick={props.remove}
                        className={
                            props.isSendingRequest
                                ? 'btn btn-primary loader-submit'
                                : ' btn btn-primary loader-submit yes-button'
                        }></ButtonLoader>
                </div>
            </ModalBody>
        </Rodal>,
        document.body,
        'remove-associate-member-popup-portal'
    );
};
